import { render, staticRenderFns } from "./IsReal.vue?vue&type=template&id=10c22e4f&"
import script from "./IsReal.vue?vue&type=script&lang=js&"
export * from "./IsReal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports